var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`labeledText  
  ${
    _vm.stacked
      ? `d-flex flex-column`
      : _vm.labelWidth || !_vm.vertical
      ? `d-flex align-top`
      : 'character-limit wrap-text'
  }
  `},[_c('div',{class:`text-label pr-1 d-inline
      ${_vm.stacked ? 'secondary--text' : ''} 
      ${_vm.child && !_vm.stacked ? 'pl-3' : ''}
    `,style:(`min-width: ${_vm.labelWidth}ch;`)},[_vm._v(" "+_vm._s(_vm.name)),(!_vm.stacked)?_c('span',[_vm._v(":")]):_vm._e()]),_c('div',{class:`font-weight-medium character-limit d-inline wrap-text
      ${_vm.color}--text 
      ${_vm.stacked ? 'text-body-1' : ''}
    `},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }